export default __webpack_public_path__ + "static/198-d2e89645be3b6b3bb4bba74c8eb092da.jpg";